const url = encodeURIComponent(window.location.href);

window.shareFacebook = function () {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, "_blank");
};

window.shareLinkedIn = function () {
  window.open(
    `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    "_blank"
  );
};

window.shareTwitter = function () {
  window.open(`https://twitter.com/intent/tweet?url=${url}`, "_blank");
};

window.copyLink = function () {
  navigator.clipboard
    .writeText(window.location.href)
    .then(() => {
      alert("Link gekopieerd!");
    })
    .catch((err) => {
      console.error("Copy failed", err);
      alert("Kopiëren mislukt. Probeer opnieuw.");
    });
};

// Dynamically assign the mail link
document.addEventListener("DOMContentLoaded", () => {
  const mailLink = document.getElementById("mailLink");
  if (mailLink) {
    mailLink.href = `mailto:?subject=Bekijk deze testimonial!&body=${url}`;
  }
});
